import { apiFetch } from '@portal/web-sdk';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Branding {
  companyName: string | null;
  logoUrl: string | null;
}

/** Company name and logo from Administration → Settings; public, so the sign-in page has them too. */
export function useBranding(): { name: string; logoUrl: string | null } {
  const { t } = useTranslation();
  const branding = useQuery({
    queryKey: ['system', 'branding'],
    queryFn: () => apiFetch<Branding>('system/branding'),
    staleTime: 5 * 60_000,
  });
  const name = branding.data?.companyName ?? t('app.name');
  useEffect(() => {
    document.title = name;
  }, [name]);
  return { name, logoUrl: branding.data?.logoUrl ?? null };
}

/** The logo, or the first letter of the name on the primary colour. */
export function BrandMark({ size }: { size: 'sm' | 'md' }) {
  const { name, logoUrl } = useBranding();
  const box = size === 'sm' ? 'size-6 rounded-md text-xs' : 'size-8 rounded-lg text-sm';
  return logoUrl ? (
    <img src={logoUrl} alt="" className={`${box} shrink-0 object-contain`} />
  ) : (
    <span
      className={`${box} flex shrink-0 items-center justify-center bg-primary font-bold text-primary-foreground`}
    >
      {name.trim().charAt(0).toUpperCase() || 'L'}
    </span>
  );
}
